import { generateClient } from 'aws-amplify/api';
import { createUserDeviceGroups, updateUserDeviceGroups, deleteUserDeviceGroups } from 'graphql/customMutations';
import { getUserDeviceGroups } from 'graphql/customQueries';
import { AUTH_MODE } from 'constants/config';

const client = generateClient();

export const apiCreateUserDeviceGroups = async (input) => {
  try {
    // Check if record already exists
    const existingGroups = await apiGetUserDeviceGroups(input.userId);
    if (existingGroups.success && existingGroups.data) {
      return {
        success: true,
        data: existingGroups.data
      }
    }
    // If not, create a new record
    const createResult = await client.graphql({
      query: createUserDeviceGroups,
      variables: {
        input: {
          userId: input.userId,
          group1: { name: input.group1.name, devices: input.group1.devices },
          group2: { name: input.group2.name, devices: input.group2.devices },
          group3: { name: input.group3.name, devices: input.group3.devices },
          group4: { name: input.group4.name, devices: input.group4.devices },
          group5: { name: input.group5.name, devices: input.group5.devices },
        }
      },
      authMode: AUTH_MODE
    });
    return { success: true, data: createResult.data.createUserDeviceGroups };
  } catch (error) {
    console.error("Error creating user device groups:", error);
    return { success: false, error: error.message };
  }
}

export const apiUpdateUserDeviceGroups = async (input) => {
  try {
    const updateResult = await client.graphql({
      query: updateUserDeviceGroups,
      variables: {
        input: {
          userId: input.userId,
          group1: { name: input.group1.name, devices: input.group1.devices },
          group2: { name: input.group2.name, devices: input.group2.devices },
          group3: { name: input.group3.name, devices: input.group3.devices },
          group4: { name: input.group4.name, devices: input.group4.devices },
          group5: { name: input.group5.name, devices: input.group5.devices },
        }
      },
      authMode: AUTH_MODE
    });
    return { success: true, data: updateResult.data.updateUserDeviceGroups };
  } catch (error) {
    console.error("Error updating user device groups:", error);
    return { success: false, error: error.message };
  }
}

export const apiDeleteUserDeviceGroups = async (userId) => {
  try {
    // Check if record exists before attempting to delete
    const existingGroups = await apiGetUserDeviceGroups(userId);
    if (!existingGroups.success || !existingGroups.data) {
      return { success: true, data: null }; // No groups to delete
    }
    // Proceed with deletion
    const deleteResult = await client.graphql({
      query: deleteUserDeviceGroups,
      variables: { input: { userId } },
      authMode: AUTH_MODE
    });
    return { success: true, data: deleteResult.data.deleteUserDeviceGroups };
  } catch (error) {
    console.error("Error deleting user device groups:", error);
    return { success: false, error: error.message };
  }
}

export const apiGetUserDeviceGroups = async (userId) => {
  try {
    const response = await client.graphql({
      query: getUserDeviceGroups,
      variables: { userId },
      authMode: AUTH_MODE
    });
    return { success: true, data: response.data.getUserDeviceGroups };
  } catch (error) {
    console.error("Error fetching user device groups:", error);
    return { success: false, error: error.message };
  }
}